export const isFetching = state => state.newsReducer.fetching || false
export const getNews = state => state.newsReducer.news || []



// WEBPACK FOOTER //
// ./src/features/News/data/selectors.js